import React from 'react';

export default function HomeIcon({
  className,
  onClick,
  fill,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.00019 13H4.00019V15V20C4.00019 21.103 4.89719 22 6.00019 22H9.00019H15.0002H18.0002C19.1032 22 20.0002 21.103 20.0002 20V15V13H21.0002C21.4042 13 21.7702 12.756 21.9242 12.383C22.0792 12.009 21.9932 11.579 21.7072 11.293L12.7072 2.29301C12.3162 1.90201 11.6842 1.90201 11.2932 2.29301L2.29319 11.293C2.00719 11.579 1.92119 12.009 2.07619 12.383C2.23019 12.756 2.59619 13 3.00019 13ZM10.0002 20V15H14.0002V20H10.0002ZM12.0002 4.41401L18.0002 10.414V15L18.0012 20H16.0002V15C16.0002 13.897 15.1032 13 14.0002 13H10.0002C8.89719 13 8.00019 13.897 8.00019 15V20H6.00019V15V12V10.414L12.0002 4.41401Z"
        fill={fill || '#474B50'}
      />
    </svg>
  );
}
